import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useStreetViewPanoramaLocation } from '~/_shared/components/streetViewPanorama/useStreetViewPanoramaLocation';
import { noop } from '~/_shared/utils/function.helpers';
import { useLocationImageGallery } from '~/customizeLocationPanel/useLocationImageGallery';
import { activeMapElementsClearState } from '~/store/frontendState/activeMapElements/activeMapElements.actionCreators';
import { frontendStateStreetViewSet } from '~/store/frontendState/mapTools/streetView/streetView.actionCreators';
import { useActivePlaceSelector } from '~/store/frontendState/places/places.selectors';
import { mapSettingsPlacesRemovePlaceFromSearch } from '~/store/mapSettings/places/mapSettingsPlaces.actionCreators';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';
import { useGetPlaceFromActivePlace } from '../../mapTools/placesTool/hooks/useGetPlaceFromActivePlace';
import { PlaceDetailsComponent } from './placeDetails.component';

export const PlaceDetailsContainer = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const dispatch = useDispatch();
  const activePlace = useActivePlaceSelector();
  const isPresentationalMap = useIsMapPresentationalSelector();

  const {
    placeDataLoaded,
    place,
    placeIndex,
    placeSearch,
  } = useGetPlaceFromActivePlace(activePlace);

  const {
    streetViewLocation,
    isLoading: streetViewLocationLoading,
  } = useStreetViewPanoramaLocation(placeDataLoaded && place ? place.location : null);

  const openStreetView = useCallback(() => {
    if (streetViewLocation) {
      dispatch(frontendStateStreetViewSet(streetViewLocation));
    }
  }, [dispatch, streetViewLocation]);

  const gallery = useLocationImageGallery({
    images: [],
    onImageClick: noop,
    onStreetViewClick: openStreetView,
    streetViewLocation: !streetViewLocationLoading ? streetViewLocation : null,
  });

  if (!placeDataLoaded || !placeSearch || !place) {
    return null;
  }

  const onRemovePlaceFromSearch = () => {
    dispatch(activeMapElementsClearState()); // close the right sidebar
    dispatch(mapSettingsPlacesRemovePlaceFromSearch({ searchId: placeSearch.id, placeId: place.id }));
  };

  return (
    <PlaceDetailsComponent
      placeSearch={placeSearch}
      placeIndex={placeIndex}
      place={place}
      onClose={onClose}
      onExpandClick={openStreetView}
      onRemoveFromSearchResults={isPresentationalMap ? undefined : onRemovePlaceFromSearch}
      gallery={gallery.galleryItems.length > 0 ? gallery : undefined}
    />
  );
};
